import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';
import React, {PropsWithChildren, ReactNode} from 'react';

type LayoutProps = PropsWithChildren<{ navigation: ReactNode }>

const Layout: React.FC<LayoutProps> = ({children, ...rest}) => {
    return <AppLayout
        content={children}
        toolsHide {...rest}
        navigationWidth={185}
    />
}

export default Layout;
